module.exports = __webpack_public_path__ + "assets/font/SourceHanSans-Normal-797a1896.ttf";